// Owner-specific routes
import { lazy } from 'react';
import React from 'react';
import OwnerDashboard from '@/pages/inside/owner/Dashboard';

// Owner pages
const Tenants     = lazy(() => import('@/pages/inside/owner/Tenants'));
const Plans       = lazy(() => import('@/pages/inside/owner/Plans'));
const Modules     = lazy(() => import('@/pages/inside/owner/Modules'));
const PortalSettings = lazy(() => import('@/pages/inside/owner/PortalSettings'));
const TenantAccess   = lazy(() => import('@/pages/inside/owner/TenantAccess'));

export const ownerRoutes = [
    {
        path: '/dashboard',
        component: OwnerDashboard,
        menuItem: { key: '/dashboard', label: 'Dashboard' },
    },
    {
        path: '/tenants',
        component: Tenants,
        menuItem: { key: '/tenants', label: 'Tenants' },
    },
    {
        // Accessed via right-click "Manage Access" — no sidebar entry
        path: '/tenant-access/:tenantId',
        component: TenantAccess,
    },
    {
        path: '/plans',
        component: Plans,
        menuItem: { key: '/plans', label: 'Plans' },
    },
    {
        path: '/modules',
        component: Modules,
        menuItem: { key: '/modules', label: 'Modules' },
    },
    {
        path: '/settings',
        component: PortalSettings,
        menuItem: { key: '/settings', label: 'Settings' },
    },
];
